export const NARROW_SCREEN_PANEL_Z_INDEX = 1000
